import React from 'react';
import styles from './WorkingIndicator.module.scss';

/**
 * Shown while the agent is working but nothing else on screen says so:
 * before the first event of a turn, while the model thinks, and between
 * tool calls (when the last card has finished and the next has not
 * started). A spinning tool card is its own indicator, so callers hide
 * this while one is pending.
 */
export const WorkingIndicator: React.FC = () => (
  <div className={styles.working} role="status" aria-live="polite">
    <span className={styles.dot} />
    <span className={styles.dot} />
    <span className={styles.dot} />
    <span className={styles.label}>Working…</span>
  </div>
);
